import { FetchingProjectItemsActionType, PersistItemsActionType, PersistProjectItemsActionType } from 'features/Persist/actionTypes';
import { PersistProjectItemsReducer } from 'features/Persist/reducerTypes';
import { ProjectIsActiveResponse } from 'services/tenantManagementService';
import { PROJECT_ROLES_FETCHING, PROJECT_ROLES_SET } from './action';


export const projectRolesReducer = (state = new PersistProjectItemsReducer<ProjectIsActiveResponse>(), action: PersistProjectItemsActionType<ProjectIsActiveResponse> | PersistItemsActionType<ProjectIsActiveResponse> | FetchingProjectItemsActionType): PersistProjectItemsReducer<ProjectIsActiveResponse> => {
	switch (action.type) {
		case PROJECT_ROLES_FETCHING: {
			const { fetching, projectId } = action as FetchingProjectItemsActionType;

			return {
				projectMap: {
					...state.projectMap,
					[projectId]: {
						isInitialized: state.projectMap[projectId]?.isInitialized || false,
						fetching,
						items: state.projectMap[projectId]?.items || [],
						itemsMap: state.projectMap[projectId]?.itemsMap || {}
					}
				}
			}
		}
		case PROJECT_ROLES_SET:
			const { items, projectId } = action as PersistProjectItemsActionType<ProjectIsActiveResponse>;

			const itemsMap = items.reduce(
				(map: { [id: number]: ProjectIsActiveResponse }, item) => {
					map[item.id] = item;
					return map;
				},
				{}
			)

			const projectMap = {
				...state.projectMap,
				[projectId]: {
					isInitialized: true,
					fetching: false,
					items,
					itemsMap
				}
			}

			return {
				projectMap
			}
		default:
			return state;
	}
};
